import ShareholderBenefitStore from '../ShareholderBenefitStore';

/**
 * @module ShareholderBenefits/Search/ShareholderBenefitSearchStore
 */
const ShareholderBenefitSearchStore = ShareholderBenefitStore;

export default ShareholderBenefitSearchStore;
